import {
  Modal as UIModal,
  ModalBackdrop,
  ModalContent
} from "@gluestack-ui/themed";
import { ForwardedRef, forwardRef } from "react";
import { IModalRefProps, ModalProps } from "./types";
import { useModalController } from "./controller";

export const Modal = forwardRef(function Drawer(
  { children, maxWidth = 570 }: ModalProps,
  ref: ForwardedRef<IModalRefProps>
) {
  const { isOpen, handleClose } = useModalController({ ref });

  return (
    <UIModal
      isOpen={isOpen}
      onClose={handleClose}
      overflow="hidden"
      focusable={false}
      useRNModal // Makes modal always be at the center of the screen (avoid problems with scrollViews)
    >
      <ModalBackdrop />
      <ModalContent
        bg="$backgroundLight0"
        width="80%"
        maxWidth={maxWidth}
        focusScope={false}
      >
        {children}
      </ModalContent>
    </UIModal>
  );
});
